import { useAuth } from '@teko/auth-react';
import { useGlobalData, useTenantConfig } from 'contexts';
import dynamic from 'next/dynamic';
import { SmartComponentProps } from '@teko-builder/smart-activation';

// lazy import
const SmartComponent = dynamic(() => import('@teko-builder/smart-activation'));

type SmartComponentEnvType = SmartComponentProps['env'];

export const SmartBanner = () => {
  const { getProcessEnv } = useGlobalData();
  const { user, loading: profileLoading } = useAuth();

  // tracking app id
  const trackingAppId = getProcessEnv('TRACKER_APP_ID');

  // env of landing builder
  const landingBuilderEnv = getProcessEnv(
    'LANDING_BUILDER_ENV',
  ) as SmartComponentEnvType;

  const { smartActivationConfig } = useTenantConfig();

  const { appId, sessionPeriodMinutes } = smartActivationConfig || {};
  // user has to login before show smart banner
  const iamId = user?.userId;

  const showSmartBanner = !profileLoading && appId;

  if (!showSmartBanner) return null;

  return (
    <SmartComponent
      env={landingBuilderEnv}
      configs={{
        appId,
        trackingAppId,
        iamId,
        sessionPeriodMinutes,
      }}
    />
  );
};
